import { type InfiniteData, useInfiniteQuery } from '@tanstack/react-query';
import {
  useApi,
  GetIssueRelationshipCount200Response,
  IssueRelationshipCountFilteringDtoOptions,
} from '@issuemanager/api-client';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';

export type UseInfiniteIssueRelationshipCountParamsObject = {
  page?: number;
  limit?: number;
  filter?: IssueRelationshipCountFilteringDtoOptions;
};

export interface UseInfiniteIssueRelationshipCountParams {
  params?: UseInfiniteIssueRelationshipCountParamsObject;
  enabled?: boolean;
}

export function useInfiniteIssueRelationshipCount({
  params = {},
  enabled = true,
}: UseInfiniteIssueRelationshipCountParams) {
  const { page = 0, limit = 10, filter } = params;

  const api = useApi();

  const queryKey = ['issue-relationship-count', page, limit, filter, enabled];

  return useInfiniteQuery<
    GetIssueRelationshipCount200Response,
    ExtendedAxiosError,
    InfiniteData<GetIssueRelationshipCount200Response>,
    typeof queryKey,
    number
  >({
    queryKey,
    queryFn: ({ pageParam }) =>
      api.issueRelationshipCountApi
        .getIssueRelationshipCount(filter, pageParam, limit)
        .then((r) => r.data),
    enabled,
    initialPageParam: page,
    getNextPageParam: (lastPage) =>
      lastPage.meta.hasNextPage ? lastPage.meta.page + 1 : undefined,
  });
}
